import store from '@/store'

export default {
    props: {},
    methods: {
        goBack(pageName) {
            if (!this.hasHistory() || this.hasExternalReferrer()) {
                this.$router.push({ name: pageName })
                return
            }

            this.$router.go(-1)
        },

        hasHistory() {
            return window.history.length > 2
        },

        hasExternalReferrer() {
            const lastPage = store.getters['history/lastPage']
            return lastPage.name === null
        },
    },
}
